import { defineMessages, IntlShape } from 'react-intl'

import { DatingFields } from 'components/page/DatingProfile/DatingProfile.constants'
import { GQLForeignRootQuery } from 'components/page/ForeignProfile/gql/__generated__/ForeignRoot'
import { GQLZodiacSign } from 'generated-graphql/graphql'

import { iconsText } from '../../Profile.constants'
import { ProfileListType } from '../../Profile.types'

const title = defineMessages({
  [GQLZodiacSign.Bliznezi]: {
    id: 'astro.sign.gemini',
    defaultMessage: 'Близнецы',
  },
  [GQLZodiacSign.Deva]: {
    id: 'astro.sign.virgo',
    defaultMessage: 'Дева',
  },
  [GQLZodiacSign.Kozerog]: {
    id: 'astro.sign.capricorn',
    defaultMessage: 'Козерог',
  },
  [GQLZodiacSign.Lev]: {
    id: 'astro.sign.leo',
    defaultMessage: 'Лев',
  },
  [GQLZodiacSign.Oven]: {
    id: 'astro.sign.aries',
    defaultMessage: 'Овен',
  },
  [GQLZodiacSign.Rak]: {
    id: 'astro.sign.cancer',
    defaultMessage: 'Рак',
  },
  [GQLZodiacSign.Ribi]: {
    id: 'astro.sign.pisces',
    defaultMessage: 'Рыбы',
  },
  [GQLZodiacSign.Skorpion]: {
    id: 'astro.sign.scorpio',
    defaultMessage: 'Скорпион',
  },
  [GQLZodiacSign.Strelez]: {
    id: 'astro.sign.sagittarius',
    defaultMessage: 'Стрелец',
  },
  [GQLZodiacSign.Telez]: {
    id: 'astro.sign.taurus',
    defaultMessage: 'Телец',
  },
  [GQLZodiacSign.Vesi]: {
    id: 'astro.sign.libra',
    defaultMessage: 'Весы',
  },
  [GQLZodiacSign.Vodoley]: {
    id: 'astro.sign.aquarius',
    defaultMessage: 'Водолей',
  },
})

export const findAstroLexeme = (
  profile: GQLForeignRootQuery['user'],
  intl: IntlShape
) => {
  if (profile?.zodiacSign) {
    return [
      {
        icon: iconsText[DatingFields.AstroSign],
        title: intl.formatMessage(title[profile.zodiacSign]),
        'data-name': 'text-zodiac-sign',
      },
    ] as ProfileListType[]
  }

  return null
}
